import { Directive, ElementRef, OnDestroy } from '@angular/core';
import { of, fromEvent, Observable, Subscription } from 'rxjs';
import { switchMap, takeUntil, map } from 'rxjs/operators';

@Directive({
  selector: '[appZoomAndMove]',
})
export class ZoomAndMoveDirective implements OnDestroy {
  subscriptionDrag: Subscription;
  initWidth: any;
  subscriptionMouseWheel: Subscription;

  constructor(private el: ElementRef) {
    this.getDragAndMouseWheel();
  }

  getDragAndMouseWheel() {
    const img = this.el.nativeElement;

    setTimeout(() => {
      const imgs = img.querySelectorAll('img');
      imgs.forEach(i => i.ondragstart = () => false);
    }, 100);

    // tslint:disable-next-line:no-shadowed-variable
    const getWidth = (img: any) => {
      const width = getComputedStyle(img).width;
      return width;
    };

    let initWidth;

    const mouseDown$ = fromEvent(img, 'mousedown');
    const mouseMove$ = fromEvent(document, 'mousemove');
    const mouseUp$ = fromEvent(document, 'mouseup');
    const mouseWheel$: Observable<MouseWheelEvent> = fromEvent(
      img,
      'mousewheel'
    );

    this.subscriptionMouseWheel = mouseWheel$
      .pipe(
        switchMap((e: MouseWheelEvent) => {
          e.stopPropagation();
          // tslint:disable-next-line:no-string-literal
          return of({ width: getWidth(img), wheelDelta: e['wheelDelta'] });
        })
      )
      .subscribe((e: any) => {
        const currentWidth = parseInt(e.width.split('px')[0], 10);
        if (!initWidth) {
          initWidth = currentWidth;
          this.initWidth = initWidth;
        }
        const width =
          currentWidth +
          (e.wheelDelta > 0 ? initWidth * 0.1 : initWidth * -0.1);

        img.style.width = `${width}px`;
      });

    this.subscriptionDrag = mouseDown$.pipe(

      switchMap(event => {
        return (
          of({
            pos: getTranslate(img),
            event
          }).pipe(
            takeUntil(mouseMove$)
          )
        );
      }),
      switchMap((initialState: { pos; event: MouseEvent }) => {
        const initialPos = initialState.pos;
        const { clientX, clientY } = initialState.event;
        return mouseMove$.pipe(
          map((moveEvent: MouseEvent) => ({
            x: moveEvent.clientX - clientX + initialPos.x,
            y: moveEvent.clientY - clientY + initialPos.y
          })),
          takeUntil(
            mouseUp$
            // .do(() => box.classList.remove('blink'))
          )
        );
      })
    ).subscribe(pos => {
      setTranslate(img, pos);
    });

    function setTranslate(element, pos) {
      element.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
    }

    function getTranslate(element) {
      const style = getComputedStyle(element);
      const regExp = /matrix\((\d+,\s){4}(\d+),\s(\d+)/i;
      // const result = style.transform.match(regExp)
      const result = style.transform.replace(/\s/g, '').split(',');
      if (result.length === 6) {
        return {
          x: parseInt(result[4], 10),
          y: parseInt(result[5], 10)
        };
      } else {
        return {
          x: 0,
          y: 0
        };
      }
    }
  }

  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    this.subscriptionDrag.unsubscribe();
    this.subscriptionMouseWheel.unsubscribe();
  }
}
